import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2GameIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 36.761 47",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47),
    children: [/*#__PURE__*/jsx("path", {
      d: "M10.261 34v-4.5c0-4.574 4.5-9 4.5-12"
    }), /*#__PURE__*/jsx("path", {
      d: "M28.261 34V17.5A10.5 10.5 0 0017.761 7c0-4.5-3.5-6-7.5-6v6l-8 5.716a3 3 0 00-.656 4.24l1.36 1.814a3 3 0 003.35 1.046l6.946-2.316h4.5M35.607 42.566c-.578-1.53-2.816-6.688-7.346-8.566h-18c-4.53 1.878-6.768 7.036-7.346 8.566a2.326 2.326 0 00-.154.834 2.6 2.6 0 002.6 2.6h27.8a2.6 2.6 0 002.6-2.6 2.326 2.326 0 00-.154-.834z"
    })]
  });
};

export { PM2GameIcon };
//# sourceMappingURL=game.js.map
